import { Cubby } from "../stores/Cubby";

export const currentlyFocusedLedgerItemJson = (cubby: Cubby) => {
  const id = cubby.currentlyFocusedLedgerItemId;
  if (!id) {
    return [null, null];
  }

  // Search in payOffchainEvents
  for (const payOffChainEvent of cubby.payOffchainEvents.data) {
    if (payOffChainEvent.event.id === id) {
      return ["Lightning Payment Sent", payOffChainEvent];
    }
  }

  // Search in invoiceUpdateEvents
  for (const invoiceUpdateEvent of cubby.invoiceUpdateEvents.data) {
    if (invoiceUpdateEvent.id === id) {
      return ["Lightning Payment Received", invoiceUpdateEvent];
    }
  }

  // Return null if no match found
  return [null, null];
};
